import React,{Component, useState} from 'react';
import {Modal,Button,Row,Col,Form, ButtonToolbar} from 'react-bootstrap';
import axios from 'axios';
import { Height } from '@material-ui/icons';
import { responsiveFontSizes } from '@material-ui/core';
import * as xlsx from 'xlsx'





export class BulkUpload extends Component {

    constructor(props){
        super(props);
        this.state = {
            ExcelList:"",
            msg:""
        }
    }
    excelData() {
        if(document.getElementById('ddlSG').value == 'Select' )
        {
          alert("Please select Service Group");
          return;
        }

        if(document.getElementById('ExcelFile').files.length == 0  )
        {
          alert("Please select File to Upload");
          return;
        }
       
            
        debugger;
        const options = {
            headers: { "content-type": "text/plain" }
        };
        if(document.getElementById('ddlSG').value == 'AO')
        {
        const article = { ServiceGroup: "AO", ExcelDataAMS: this.state.ExcelList };
        axios
            .post('https://as-mobilization-stage.accenture.com/KTPlanConfig/api/ExcelBulkUpload/GetInsertData/', article, options)
            .then((res) => {
                this.setState({ msg: res.data });
                console.log(res);
                alert(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
        }
        else
        {
            const article = { ServiceGroup: "IO", ExcelDataIMS: this.state.ExcelList };
        axios
            .post('https://as-mobilization-stage.accenture.com/KTPlanConfig/api/ExcelBulkUpload/GetInsertDataIMS/', article, options)
            .then((res) => {
                this.setState({ msg: res.data });
                console.log(res);
                alert(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
        }

            console.log(this.state.ExcelList)
    }
   
    render(){
        const readExcel =async(e)=>{
      
            const file=e.target.files[0];
            
            const data =await file.arrayBuffer(file);
            const excelfile=xlsx.read(data);
            const excelsheet=excelfile.Sheets[excelfile.SheetNames[0]];
            const exceljson=xlsx.utils.sheet_to_json(excelsheet);
            this.state.ExcelList=exceljson;
            console.log(exceljson);
            console.log(this.state.ExcelList);
        }
        return (
            <div className='container'>
            <Modal  {...this.props} size='lg'   aria-labelledby='contained-modal-title-vcenter' centered >
                <Modal.Header>
                <Modal.Title id='contained-modal-title-vcenter'>
                    Bulk Upload
                </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={12}>
                          <Form>
                          <Form.Group>
                          <div>
                              <Form.Label>Service Group</Form.Label>
                              
                              <select style={{width:100,height:37,marginBottom:10}}  name="ddlSG" id="ddlSG" class="aspNetDisabled form-control input-sm   textarea-style watermark">
                   <option value="Select">Select</option>
                   <option value="AO">AMS</option>
                   <option value="IO">IMS</option>
                  
                   </select>
                              </div>
                              <input type="file" id="ExcelFile" onChange={(e)=>readExcel(e)}/>
                    
                          </Form.Group>  
                        
                          <Form.Group>
                              <Button variant='primary' onClick={()=>this.excelData()} style={{margin:10,width:100}} className='btn-new btn-confirm'>
                                  Upload  
                              </Button> 
                              <Button onClick={this.props.onHide} style={{margin:10,backgroundColor:'gray'}} className='btn-new btn-confirm'>Close
                              </Button>
                              </Form.Group>
                          </Form>  
                        </Col>
                    </Row>
                </Modal.Body>
               
            </Modal>
            
            </div>
            
        )
 
    }
}